import * as React from 'react';

import * as styles from './HeatIndexBodySection.css';

export const HeatIndexBodySection: React.FC<React.PropsWithChildren> = ({ children }) => {
  return <div className={styles['wrapper']}>{children}</div>;
};
